import classNames from "classnames"
import LegacyButton from "legacy/LegacyButton"
import PreservedRateModal from "legacy/preserved_rates_table/PreservedRateModal"
import PropTypes from "prop-types"
import React from "react"

class PreservedRateModalButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      loading: false,
      preservedRates: [],
    }
    this.handleModalClose = this.handleModalClose.bind(this)
    this.handleModalOpen = this.handleModalOpen.bind(this)
  }

  handleModalClose() {
    this.setState({ showModal: false })
  }

  handleModalOpen() {
    this.setState({ showModal: true })
    if (this.props.fetchUrl) {
      this.setState({ loading: true })
      $.get(this.props.fetchUrl, (data) => {
        this.setState({
          preservedRates: data,
          loading: false,
        })
      }).fail((data) => {
        this.setState({ errorLoadingData: data.responseJSON })
      })
    }
  }

  renderModalBtn() {
    if (
      (this.props.preservedRates && this.props.preservedRates.length > 0) ||
      this.props.fetchUrl
    ) {
      return (
        <LegacyButton
          onClick={this.handleModalOpen}
          className={classNames("btn btn-tertiary", {
            "w-full": this.props.fullWidth,
          })}
        >
          View Rates
        </LegacyButton>
      )
    }
    return null
  }

  render() {
    return (
      <div>
        {this.renderModalBtn()}
        {this.state.showModal && (
          <PreservedRateModal
            preservedRates={
              this.props.preservedRates || this.state.preservedRates
            }
            handleModalClose={this.handleModalClose}
            loading={this.state.loading}
            telescopeCtaPath={this.props.telescopeCtaPath}
            telescopeEnabled={this.props.telescopeEnabled}
          />
        )}
      </div>
    )
  }
}

// Note: jQuery ($) is loaded globally, not via an import

PreservedRateModalButton.propTypes = {
  preservedRates: PropTypes.array,
  fetchUrl: PropTypes.string,
  fullWidth: PropTypes.bool,
  telescopeCtaPath: PropTypes.string,
  telescopeEnabled: PropTypes.bool,
}

export default PreservedRateModalButton
